/* istanbul ignore file */
export { default } from './Ribbon';
